import { Button, TextField, FormControl, InputLabel, InputAdornment, ListItemButton, Checkbox } from "@mui/material"
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormHelperText from '@mui/material/FormHelperText';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ProductSubOption from "./ProductSubOption";
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { useCallback, useEffect, useState } from "react";
import { capitalizeText } from "../utils/strings";
import Helper from "./Helper";
import Confirmation from "./Confirmation";
import { OPTIONS_VARIANTS } from "../utils/structures";
import EasySnackBar from "./EasySnackBar";

export default function ProductOption(props) {

    const [showConfirmation, setShowConfirmation] = useState(false)

    //1=una / 0=varias / -1=todas
    const [elegibleOptions, setElegibleOptions] = useState(1)
    const [elegibleCount, setElegibleCount] = useState(1)

    const [newSubOptionName, setNewSubOptionName] = useState("")
    const [display, setDisplay] = useState(false)
    const [isMandatory, setIsMandatory] = useState(false)

    const [optionVariant, setOptionVariant] = useState(OPTIONS_VARIANTS.selectOption)

    const [errorMessage, setErrorMessage] = useState('')


    // Para que se me actualicen las subopciones nada mas
    useEffect(() => {
        setIsMandatory(props.productOptions[props.optionIndex].isMandatory ?
            props.productOptions[props.optionIndex].isMandatory : false)
        setElegibleCount(props.productOptions[props.optionIndex].elegibleOptions)
        setElegibleOptions(props.productOptions[props.optionIndex].elegibleOptions)
        setOptionVariant(props.productOptions[props.optionIndex].type)
    }, [])

    const addSubOption = () => {

        let updatedProductOptions = props.productOptions
        const capitalizedName = capitalizeText(newSubOptionName)

        if (updatedProductOptions[props.optionIndex].subOptions) {

            const nameExists = updatedProductOptions[props.optionIndex].subOptions.some(subOption => subOption.name === capitalizedName)

            if (nameExists) {
                setErrorMessage('Esta versión ya tiene una opción con ese nombre')

            } else {
                updatedProductOptions[props.optionIndex].subOptions = updatedProductOptions[props.optionIndex].subOptions.concat({
                    name: capitalizedName, price: 0, calories: 0, visible: true, units: 0
                })
            }

        } else {
            updatedProductOptions[props.optionIndex].subOptions = [{ name: capitalizedName, price: 0, calories: 0, visible: true, type: optionVariant, units: 0 }]
        }

        props.setProductOptions(updatedProductOptions)
        setNewSubOptionName("")
    }

    const updateSubOption = useCallback((optionIndex, subOptionIndex, newSubOption) => {
        let updatedOptions = [...props.productOptions]

        updatedOptions[optionIndex].subOptions[subOptionIndex] = newSubOption

        props.setProductOptions(updatedOptions)
    }, [props.productOptions, props.setProductOptions])

    const removeSubOption = useCallback((optionIndex, subOptionIndex) => {
        let updatedOptions = [...props.productOptions]

        updatedOptions[optionIndex].subOptions = props.productOptions[optionIndex].subOptions.filter((elem, index) => {
            return (index !== subOptionIndex)
        })

        props.setProductOptions(updatedOptions)
    }, [props.productOptions, props.productOptions, props.setProductOptions])

    const removeOption = useCallback(() => {
        const updatedOptions = props.productOptions.filter((elem, index) => { return (index !== props.optionIndex) })
        props.setProductOptions(updatedOptions)
    }, [props.productOptions, props.setProductOptions])


    const updateElegibleOptions = newCount => {
        let updatedOptions = [...props.productOptions]

        updatedOptions[props.optionIndex].elegibleOptions = newCount

        props.setProductOptions(updatedOptions)
    }

    const updateIsMandatory = checked => {
        let updatedOptions = [...props.productOptions]

        updatedOptions[props.optionIndex].isMandatory = checked

        props.setProductOptions(updatedOptions)
        setIsMandatory(checked)
    }

    const updateOptionVersion = version => {
        let updatedOptions = [...props.productOptions]

        updatedOptions[props.optionIndex].type = version

        props.setProductOptions(updatedOptions)
    }

    const handleElegible = (event, newAlignment) => {
        if (newAlignment !== null) {
            setElegibleOptions(newAlignment);

            if (newAlignment === 1) {
                setElegibleCount(1)
                updateElegibleOptions(1)
            } else if (newAlignment < 0) {
                setElegibleCount(-1)
                updateElegibleOptions(-1)
            } else if (newAlignment === 0) {
                setElegibleCount(1)
                updateElegibleOptions(1)
            }
        }
    };

    useEffect(() => {
        if (optionVariant === OPTIONS_VARIANTS.addUnits) {
            setElegibleCount(1)
        }
    }, [optionVariant])

    useEffect(() => {
        if (optionVariant === OPTIONS_VARIANTS.selectOption
            && isMandatory && elegibleOptions === -1) {
            setElegibleOptions(1)
            setElegibleCount(1)
        }
    }, [isMandatory, elegibleOptions, optionVariant])

    return (
        <>
            <Divider />

            <ListItemButton
                onClick={setDisplay.bind(this, !display)}
                sx={display ? { backgroundColor: '#FCFCFC', borderStyle: 'solid', borderWidth: '0px 1px', borderColor: '#E0E0E0' } : null}>
                <ListItemText
                    primary={props.productOptions[props.optionIndex].name}
                    secondary={"Opciones: " + props.productOptions[props.optionIndex].subOptions.length + " | Obligatoria: " +
                        (isMandatory ? "Si" : "No") + " | Elegibles: " + (elegibleOptions < 0 ? "Todas" : elegibleCount)}
                />

                {!props.productOptions[props.optionIndex].subOptions ?
                    <DeleteForeverIcon /> :
                    display ? <ExpandLess /> : <ExpandMore />}

            </ListItemButton>

            <Collapse in={display} timeout="auto" unmountOnExit sx={{ borderStyle: 'solid', borderWidth: '0px 1px', borderColor: '#E0E0E0' }}>

                <Stack
                    flexWrap='wrap'
                    direction='row'
                    justifyContent="space-evenly"
                    alignItems="center"
                    sx={{ backgroundColor: '#FCFCFC' }}
                >

                    <FormControl fullWidth sx={{ m: 1, backgroundColor: 'white' }}>
                        <InputLabel id="demo-simple-select-label">Tipo de version</InputLabel>
                        <Select
                            label="Tipo de version"
                            value={optionVariant}
                            onChange={e => { setOptionVariant(e.target.value); updateOptionVersion(e.target.value) }}
                        >
                            <MenuItem value={OPTIONS_VARIANTS.selectOption}>Poder seleccionar una o varias opciones</MenuItem>
                            <MenuItem value={OPTIONS_VARIANTS.addUnits}>Poder agregar varias unidades de la misma opción</MenuItem>
                        </Select>
                    </FormControl>

                    {optionVariant === OPTIONS_VARIANTS.selectOption ?
                        <>
                            <Stack alignItems="center" spacing={2}>

                                <div>
                                    <span>
                                        {isMandatory ? 'Cuantas opciones DEBE elegir?' : 'Cuantas opciones PUEDE elegir?'}
                                    </span>
                                    <Helper text='Indica de todas las opciones dentro de esta versión cuantas podrá elegir el usuario simultaneamente' />
                                </div>
                                <ToggleButtonGroup
                                    color="primary"
                                    value={elegibleOptions}
                                    exclusive
                                    onChange={handleElegible}
                                    aria-label="Platform"
                                >
                                    <ToggleButton value={1}>Una</ToggleButton>
                                    <ToggleButton value={0}>Varias</ToggleButton>
                                    {isMandatory ? null : <ToggleButton value={-1}>Todas</ToggleButton>}
                                </ToggleButtonGroup>

                                {elegibleOptions !== 0 ? null :
                                    <TextField
                                        id="outlined-basic"
                                        label="Cantidad"
                                        variant="outlined"
                                        value={elegibleCount}
                                        required
                                        onChange={e => {
                                            const regex = /^[0-9]*$/
                                            const inputVal = e.target.value

                                            if (inputVal === "") {
                                                setElegibleCount(0)
                                                updateElegibleOptions(0)

                                            } else if (regex.test(inputVal)) {
                                                setElegibleCount(inputVal.at(0) === '0' && inputVal.length > 0 ? inputVal.slice(1,) : inputVal)
                                                updateElegibleOptions(inputVal)
                                            }
                                        }}
                                    />
                                }
                            </Stack>

                            <FormControlLabel
                                control={<Checkbox />}
                                label="Es obligatorio elegir cierta cantidad de opciones en total?"
                                checked={isMandatory}
                                onChange={e => updateIsMandatory(e.target.checked)}
                            />
                        </> :
                        <>
                            <FormControlLabel
                                control={<Checkbox />}
                                label="Es obligatorio agregar cierta cantidad de unidades en total?"
                                checked={isMandatory}
                                onChange={e => updateIsMandatory(e.target.checked)}
                            />

                            {!isMandatory ? null :
                                <TextField
                                    sx={{ m: 1, backgroundColor: 'white' }}
                                    label="Cantidad total"
                                    variant="outlined"
                                    value={elegibleCount}
                                    required
                                    onChange={e => {
                                        const regex = /^[0-9]*$/
                                        const inputVal = e.target.value

                                        if (inputVal === "") {
                                            setElegibleCount(0)
                                            updateElegibleOptions(0)

                                        } else if (regex.test(inputVal)) {
                                            setElegibleCount(inputVal.at(0) === '0' && inputVal.length > 0 ? inputVal.slice(1,) : inputVal)
                                            updateElegibleOptions(inputVal)
                                        }
                                    }}
                                />}

                            <Helper text='El total es sumando todas las unidades de los extras, si quieres un limite especifico
                             por extra puedes desactivar esto y colocar la cantidad maxima en cada extra por separado' />
                        </>}
                </Stack>

                <Stack spacing={2} margin={'25px'}>

                    {props.productOptions[props.optionIndex].subOptions ?
                        props.productOptions[props.optionIndex].subOptions.map((subOption, subIndex) => {
                            return (
                                <div key={subIndex}>
                                    <ProductSubOption
                                        updateSubOption={updateSubOption}
                                        removeSubOption={removeSubOption}
                                        optionIndex={props.optionIndex}
                                        subOptionIndex={subIndex}
                                        subOption={subOption}
                                        option={props.productOptions[props.optionIndex]}
                                    />
                                </div>
                            )
                        }) : null}

                    <Stack direction='row'>
                        <FormControl variant="outlined" sx={{ width: '100%' }}>
                            <InputLabel htmlFor="outlined-adornment-password">Nueva Opción</InputLabel>
                            <OutlinedInput
                                inputProps={{ 'aria-label': 'search google maps' }}
                                onChange={e => { setNewSubOptionName(e.target.value) }}
                                value={newSubOptionName}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        addSubOption();
                                    }
                                }}
                                endAdornment={
                                    <InputAdornment position="end">

                                        <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                                        <IconButton onClick={addSubOption} color="primary">
                                            <AddCircleOutlineOutlinedIcon />
                                        </IconButton>

                                    </InputAdornment>
                                }
                                label="Nueva Opción"
                            />
                            <FormHelperText>Maximo 100 caracteres</FormHelperText>
                        </FormControl>
                        <Helper
                            text={`Crea una nueva opción para que tu cliente elija en '` + props.productOptions[props.optionIndex].name + `'`}
                            style={{ marginBottom: '20px' }}
                        />
                    </Stack>

                    <Button
                        onClick={setShowConfirmation.bind(this, true)}
                        variant="outlined"
                        color="error"
                    >
                        Eliminar Versión
                    </Button>

                </Stack>

            </Collapse>

            <Confirmation
                action={removeOption}
                open={showConfirmation}
                setOpen={setShowConfirmation}
                title={"Estás seguro de que quieres eliminar esta versión?"}
                description={"Se perderán todas las opciones relacionadas a esta versión"}
                actionMsg={"Eliminar"}
                rejectMsg={"Volver"}
            />

            <EasySnackBar
                severity='error'
                key='1'
                message={errorMessage}
                setMessage={setErrorMessage}
            />
        </>
    )
}